// ** ADDON PRODUCTS ** //
theme.AjaxAddonProduct = (function() {
    
    var status = {
        loading: false
    };
    function ProductForm(button) {
        this.addToCartButton = button;
        
        if (this.addToCartButton) {
            this.addToCartButton.addEventListener('click', this.addItem.bind(this));
        }
    }

    ProductForm.prototype = {
        addItem: function(evt) {
            evt.preventDefault();

            if (status.loading) {
                return;
            }

            var index = this.addToCartButton.dataset.index; 
            var dropdownSelector = `#addonOptions-${index}`;
            var dropdown = document.querySelector(dropdownSelector);

            var addonId;
            if (dropdown) {
                addonId = dropdown.value; // Get the selected variant's ID from the dropdown
            } else {
                addonId = this.addToCartButton.getAttribute('data-addon-id'); // Fallback to the first variant's ID if no dropdown exists
            }

            var iconSpan = this.addToCartButton.querySelector('.btn--circle');
            iconSpan.classList.add('btn--loading'); // Add the loading class to the span

            status.loading = true;

            var items = [{
                id: addonId,
                quantity: 1
            }];

            fetch('/cart/add.js', {
                method: 'POST',
                body: JSON.stringify({ items: items }),
                headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest'
                },
                credentials: 'same-origin'
            })
            .then(response => response.json())
            .then(data => {
                this.success(data);
            })
            .catch(error => {
                this.error(error);
            })
            .finally(() => {
                status.loading = false;
                iconSpan.classList.remove('btn--loading'); // Remove the loading class from the span
            });
        },   

        success: function(data) {
            document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
                detail: {
                    cartData: data
                },
                bubbles: true
            }));
        },

        error: function(error) {
            console.error('Error adding items to cart:', error);
            document.dispatchEvent(new CustomEvent('ajaxProduct:error', {
                detail: {
                    error: error
                },
                bubbles: true
            }));
        }
    };

    return ProductForm;
})();

// Initialize AjaxAddonProduct
document.addEventListener('DOMContentLoaded', function() {
    var buttons = document.querySelectorAll('.quick-add-btn[data-addon-id]');
    buttons.forEach(function(button) {
        new theme.AjaxAddonProduct(button);
    });
});


// Update images and prices for addon products
document.addEventListener("DOMContentLoaded", function() {
    // Select all dropdowns
    var dropdowns = document.querySelectorAll("select[name='addonOptions']");


    dropdowns.forEach(function(dropdown) {

        dropdown.addEventListener("change", function(event) {
            
            // Get the selected option
            var selectedOption = event.target.options[event.target.selectedIndex];

            // Get the value of the variant.id
            var variantId = selectedOption.value;

            // Get the value of the featuredImage data attribute
            var featuredImageData = selectedOption.getAttribute('data-image');

            // Get the value of the variant.price
            var variantPrice = selectedOption.getAttribute('data-price');

            // Get the index of the addon
            var addonIndex = dropdown.getAttribute('data-index');

            // Update the src attribute of addonImage
            var addonImage = document.getElementById('addonImage-' + addonIndex);

            if (addonImage) {
                addonImage.src = featuredImageData;
            } else {
                console.error("Addon Image not found.");
            }

            // Update the addonPrice span
            var addonPriceSpan = document.getElementById('addonPrice-' + addonIndex);
            if (addonPriceSpan) {
                addonPriceSpan.innerText = "+ " + variantPrice;
            } else {
                console.error("Addon Price Span not found.");
            }
        });
    });
});